import { CoreStoreType, GameCommunicationMessageType, IGameCommunicationProcessor } from '@pp/core';

import { GameStore } from '../../../store/GameStore';
import { mwGameStateActions } from '../../../store/slices/mwGame/slice';
export interface BetsStatsMsg extends GameCommunicationMessageType {
  beforeInit: boolean;
  count: number;
  delay: number;
  seq: number;
  stats: {
    bet_1: number;
    bet_2: number;
    bet_5: number;
    bet_8: number;
    bet_10: number;
    bet_15: number;
    bet_20: number;
    bet_30: number;
    bet_40: number;
  };
}

export class GameCommunicationBetsStatsProcessor implements IGameCommunicationProcessor {
  messageName = 'betResultStats';

  process(message: any, store: CoreStoreType): void {
    const processDelay: number = 0;
    setTimeout(() => {
      this.handleBetsStats(message, store);
    }, processDelay);
  }
  private handleBetsStats(message: BetsStatsMsg, store: GameStore): void {
    if (message.stats) {
      const data = {
        '1': message.stats.bet_1,
        '2': message.stats.bet_2,
        '5': message.stats.bet_5,
        '8': message.stats.bet_8,
        '10': message.stats.bet_10,
        '15': message.stats.bet_15,
        '20': message.stats.bet_20,
        '30': message.stats.bet_30,
        '40': message.stats.bet_40,
      };
      store.dispatch(mwGameStateActions.setResultPercentage(data));
    }
  }
}
